'use client';
export function FileAttachmentTray({ attachmentTrayProps, renderAttachmentTray, }) {
    return renderAttachmentTray(attachmentTrayProps);
}
//# sourceMappingURL=indexComponents.js.map